import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import SocialStatsChart from "./stats-chart";
import "./index.css";

class SocialStats extends Component {
  render() {
    return (
      <div className="row mt-4">
        <div className="col">
          <div
            className="social-stats-col  p-3"
            style={{
              background: "var(--cardBg)",
              border: "var(--card-border)",
              transition: "color 0.2s ease-out, background 0.2s ease-out"
            }}
          >
            <div className="market-inner-col d-flex justify-content-between mb-3">
              <span className="badge badge-warning market-bedge">
                Social stats
              </span>
              {/* <img
                className="img-fluid"
                src={require("../../assets/icons/share-icon.svg")}
                alt="share"
              /> */}
            </div>

            <div className="row d-flex pt-3 pb-3">
              <div className="col text-center p-0">
                <img
                  className="img-fluid"
                  src={require("../../assets/icons/reddit-icon-white.svg")}
                  alt="Reddit-Icon"
                  style={{ filter: "var(--social-icon)" }}
                />
                <h1
                  className="sub-heading pt-3"
                  style={{ color: "var(--social-stats-text)" }}
                >
                  441
                </h1>
                <p
                  className="p-body-small pt-1"
                  style={{ color: "var(--social-stats-text)" }}
                >
                  SUBSCRIBERS
                </p>
              </div>
              <div className="col text-center p-0">
                <img
                  className="img-fluid"
                  src={require("../../assets/icons/telegram-icon-white.svg")}
                  alt="Telegram-Icon"
                  style={{ filter: "var(--social-icon)" }}
                />
                <h1
                  className="sub-heading pt-3"
                  style={{ color: "var(--social-stats-text)" }}
                >
                  779
                </h1>
                <p
                  className="p-body-small pt-1"
                  style={{ color: "var(--social-stats-text)" }}
                >
                  USERS
                </p>
              </div>
              <div className="col text-center p-0">
                <img
                  className="img-fluid"
                  src={require("../../assets/icons/twitter-icon-white.svg")}
                  alt="Twitter-Icon"
                  style={{ filter: "var(--social-icon)" }}
                />
                <h1
                  className="sub-heading pt-3"
                  style={{ color: "var(--social-stats-text)" }}
                >
                  3716
                </h1>
                <p
                  className="p-body-small pt-1"
                  style={{ color: "var(--social-stats-text)" }}
                >
                  FOLLOWERS
                </p>
              </div>
            </div>

            <div className="row mt-1 mb-3">
              <div className="col">
                <SocialStatsChart />
              </div>
            </div>

            <div className="row">
              <div className="col text-center">
                <ul className="p-0 social-media-stats-list ">
                  <li>
                    <FontAwesomeIcon
                      icon={faCircle}
                      className="faCircle reddit"
                    />{" "}
                    <span style={{ color: "var(--social-widget-name)" }}>
                      Reddit
                    </span>
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={faCircle}
                      className="faCircle telegram"
                    />{" "}
                    <span style={{ color: "var(--social-widget-name)" }}>
                      Telegram
                    </span>
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={faCircle}
                      className="faCircle twitter"
                    />{" "}
                    <span style={{ color: "var(--social-widget-name)" }}>
                      Twitter
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SocialStats;
